import { useEffect, useState } from 'react';
import { ScreeningSetupDataType } from './AlertStatusSetupContext';

const useScreeningSetupData = (initialScreeningSetupData: ScreeningSetupDataType) => {
  const [screeningSetupData, setScreeningSetupData] = useState(initialScreeningSetupData);

  useEffect(() => {
    setScreeningSetupData(initialScreeningSetupData);
  }, [initialScreeningSetupData]);

  const [isScreeningSetupValid, setScreeningSetupValid] = useState(true);
  const [isScreeningSetupSubmissionTouched, setScreeningSetupSubmissionTouched] = useState(false);
  const [isScreeningSetupSubmitted, setScreeningSetupSubmitted] = useState(false);

  return {
    screeningSetupData,
    setScreeningSetupData,
    isScreeningSetupValid,
    setScreeningSetupValid,
    isScreeningSetupSubmissionTouched,
    setScreeningSetupSubmissionTouched,
    isScreeningSetupSubmitted,
    setScreeningSetupSubmitted,
  };
};

export default useScreeningSetupData;
